export const MESSAGE_TYPE_FILTERS = Object.freeze({
  ALL: "all",
  GUESTS: "guests",
  CONTACTS: "contacts",
  TEAM: "team",
});

export const MESSAGE_TYPE_OPTIONS = Object.freeze([
  { type: MESSAGE_TYPE_FILTERS.ALL, title: "All" },
  { type: MESSAGE_TYPE_FILTERS.GUESTS, title: "Guests" },
  { type: MESSAGE_TYPE_FILTERS.CONTACTS, title: "Contacts" },
  { type: MESSAGE_TYPE_FILTERS.TEAM, title: "Team" },
]);

export const threadMatchesMessageType = (
  thread,
  messageType = MESSAGE_TYPE_FILTERS.ALL,
) => {
  if (messageType === MESSAGE_TYPE_FILTERS.ALL) return true;

  const isTeamThread = thread?.conversation_type === "team";
  if (messageType === MESSAGE_TYPE_FILTERS.TEAM) return isTeamThread;

  const isContactThread = !isTeamThread && !!thread?.contact_category;
  if (messageType === MESSAGE_TYPE_FILTERS.CONTACTS) return isContactThread;
  if (messageType === MESSAGE_TYPE_FILTERS.GUESTS) {
    return !isTeamThread && !isContactThread;
  }

  return true;
};

export const filterThreadsByMessageType = (threads, messageType) =>
  (Array.isArray(threads) ? threads : []).filter((thread) =>
    threadMatchesMessageType(thread, messageType),
  );
